// directTo.js — DIRECT TO LISTESI, RAPORUN IKI YUZU ICIN TEK KAYNAK (22 Eyl 2026)
//
// 🔑 Serkan: *"Her direct-to raporda yazilmali."* · *"Wpt to wpt direkto
//    aliyoruz… cancel olmadigi muddetce her direkt kalmali."*
//
// iPad `navlog_data.direct_to`ya LISTE yazar (her direct ayri kayit, iptal
// edilenler `cancelledAt` ile). 22 Eyl oncesi kayit TEK `{from,to}` nesnesidir
// ve yalniz SON direct'i tasir. Rapor PDF'i (`archive-flight`) ve web'in yedek
// rapor gorunumu (`FlightReport.js`) bu fonksiyonu cagirir — ikinci kopya yok
// (Ilke 3; `inputFormat.js` ile ayni paylasim yolu).
//
// ⚠️ Kural (hangi nokta atlanir) BURADA YOK — o iPad'de (`NavLogEngine`),
//    cevabi navlog satirlarinin damgasinda. Burasi yalniz LISTEYI okur.

/** uid -> nokta adi. Parser uid'i `AD-sira` bicimindedir; nokta bulunamazsa ek atilir. */
const adOf = (uid, wpts) => {
  const u = String(uid ?? '');
  const w = (wpts || []).find((x) => x && x.uid === u);
  return (w && w.name) || u.replace(/-\d+$/, '') || '-';
};

/** `navlog_data.direct_to` (dizi ya da eski tek nesne) -> raporun listesi:
 *  `{ from, to, set_at, cancelled_at, skipped }`. Bos/bozuk veri bos liste. */
export const directListesi = (ham, wpts = []) => {
  const liste = Array.isArray(ham) ? ham : (ham && typeof ham === 'object' ? [ham] : []);
  return liste
    .filter((d) => d && (d.from || d.to))
    .map((d) => ({
      from: (typeof d.fromName === 'string' && d.fromName) ? d.fromName : adOf(d.from, wpts),
      to: (typeof d.toName === 'string' && d.toName) ? d.toName : adOf(d.to, wpts),
      set_at: typeof d.setAt === 'string' ? d.setAt : null,
      cancelled_at: typeof d.cancelledAt === 'string' ? d.cancelledAt : null,
      skipped: typeof d.skipped === 'number' ? d.skipped : null,
    }));
};
